/* eslint-disable */

import { useEffect, useState } from 'react'

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../Components/ui/card'
import { Input } from '../../Components/ui/input'
import { Button } from '../../Components/ui/button'
import { Label } from '../../Components/ui/label'
import { post } from '../../http/restservice'
import { useRecoilValueLoadable } from 'recoil'
import { UserBasketsAdmin } from '../../store/AdminStore'

const CREATE_MANDATE_ENDPOINT = '/mutualfundservice/api/mutualFund/mandateRequestByAdmin'

const MANDATE_AMOUNT_OPTIONS = [
    { label: '1 Lac', value: '100000' },
    { label: '10 Lac', value: '1000000' },
    { label: '1 Cr', value: '10000000' },
]


const CreateMandate = ({ clientCode }) => {
    const userBasketsLoadable = useRecoilValueLoadable(UserBasketsAdmin(clientCode))
    const [amount, setAmount] = useState('')
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [error, setError] = useState('')
    const [result, setResult] = useState(null)
    console.log(userBasketsLoadable, 'userBasketsLoadable')

    const draftAdminPlansExist = userBasketsLoadable?.contents?.data?.data?.some(basket => basket.basketStatus === 'DRAFT' && basket.createdSource === 'ACTION PLAN')

    console.log(draftAdminPlansExist, 'draftAdminPlansExist')


    const handleSubmit = async () => {
        setError('')
        setResult(null)

        const normalizedAmount = Number(amount)
        if (!clientCode?.trim()) {
            setError('Client code is required')
            return
        }
        if (!Number.isFinite(normalizedAmount) || normalizedAmount <= 0) {
            setError('Please select a valid amount')
            return
        }

        setIsSubmitting(true)
        try {
            const payload = {
                clientCode: clientCode.trim(),
                amount: normalizedAmount,
            }

            const response = await post(
                CREATE_MANDATE_ENDPOINT,
                payload,
                { 'Content-Type': 'application/json' },
                undefined,
            )

            if (response?.isError) {
                throw new Error(response?.response?.message || 'Failed to create mandate')
            }

            setResult(response)
        } catch (e) {
            setError(e?.message || 'Something went wrong')
        } finally {
            setIsSubmitting(false)
        }
    }

    return (
        <div className='mx-auto p-2 md:p-6 space-y-4 md:space-y-6'>
            <div>
                <h1 className='text-xl md:text-2xl lg:text-3xl font-bold tracking-tight'>Create Mandate</h1>
                <p className='text-muted-foreground text-xs md:text-sm'>
                    Create a mandate request for a client by selecting an amount.
                </p>
            </div>

            <Card>
                <CardHeader className='px-3 md:px-6'>
                    <CardTitle className='text-base md:text-lg'>
                        Mandate Request
                    </CardTitle>

                    {draftAdminPlansExist ? (
                        <CardDescription className='text-xs md:text-sm text-warning-600'>
                            Draft Admin Plans Exist. Please clear the draft admin plans before creating a mandate.
                        </CardDescription>
                    ) : null}
                </CardHeader>
                <CardContent className='space-y-4'>
                    <div className='grid gap-2 max-w-xl'>
                        <Label htmlFor='clientCode'>Client Code</Label>
                        <Input
                            disabled
                            id='clientCode'
                            value={clientCode}
                            placeholder='e.g. SSL1023'
                            autoComplete='off'
                        />
                    </div>

                    <div className='grid gap-2 max-w-xl'>
                        <Label>Amount</Label>
                        <div className='grid grid-cols-1 sm:grid-cols-3 gap-2'>
                            {MANDATE_AMOUNT_OPTIONS.map((option) => (
                                <button
                                    key={option.value}
                                    type='button'
                                    onClick={() => setAmount(option.value)}
                                    className={`rounded-md border px-3 py-2 text-sm font-medium transition-colors ${amount === option.value
                                        ? 'border-primary text-primary bg-primary-50'
                                        : 'border-gray-200 text-gray-700 hover:bg-gray-50'
                                        }`}
                                >
                                    {option.label}
                                </button>
                            ))}
                        </div>
                    </div>

                    {error && <p className='text-sm text-error-500'>{error}</p>}

                    <div className='flex items-center gap-2'>
                        <Button onClick={handleSubmit} disabled={isSubmitting} className='gap-2'>
                            {isSubmitting ? 'Submitting...' : 'Create Mandate'}
                        </Button>
                    </div>

                    {result && (
                        <div className='rounded-md border bg-secondary-50 p-3 text-xs overflow-auto max-w-3xl'>
                            <pre className='whitespace-pre-wrap'>{JSON.stringify(result, null, 2)}</pre>
                        </div>
                    )}
                </CardContent>
            </Card>
        </div>
    )
}

export default CreateMandate